import * as ActionTypes from "../ActionTypes";

export const AddAtsWorkSpaceAction = (params) => {
    return {
        type: ActionTypes.ATS_WORKSPACE_ADD_REQUEST,
        params
    }
}

